import { Pause, Play, Replay } from "@/icons";
import { cn } from "@/utils";

export const PlayButton = ({
  playing,
  togglePlay,
  progressPercentage,
  handleReplay,
  large,
}: {
  playing: boolean;
  togglePlay: (playing?: boolean) => void;
  progressPercentage: number;
  handleReplay?: () => void;
  large?: boolean;
}) => {
  const showReplay = !!handleReplay && progressPercentage >= 100;
  return (
    <button
      onClick={() => {
        showReplay ? handleReplay() : togglePlay();
      }}
      className="hover:opacity-85"
    >
      {showReplay ? (
        <Replay className="h-6 w-[18px]" />
      ) : playing ? (
        <Pause
          className={cn("h-[18px] w-[18px]", large && "h-[34px] w-[34px]")}
        />
      ) : (
        <Play
          className={cn("h-[17px] w-[18px]", large && "h-[30px] w-[34px]")}
        />
      )}
    </button>
  );
};
